export default function ({ app, redirect }) {
    // Redirect to restaurant page if already authenticated
    if (app.$localStore.get('authenticated')) {
        return redirect('/pianifica/locale');
    }
}
